import { BarProgressTheme } from "@acin.reactjs/acin-ui/progress";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";

const barProgressTheme = (
  theme: DefaultTheme,
): ComponentCSSStyle<BarProgressTheme> => ({
  variants: {
    publicAcin: {
      root: {
        width: "105px",
      },
      bar: {
        root: {
          width: "105px",
        },
        progress: {
          backgroundColor: theme.palette.secondary[500],
        },
        background: {
          backgroundColor: theme.palette.greys[100],
        },
      },
      percentage: {
        display: "none",
      },
    },
  },
});

export default barProgressTheme;
